module.exports = __webpack_public_path__ + "media/assets/images/hero-unit/character-f7decfdcc7a67ffaed72275912a05098.png";